import React, { useRef, useState } from 'react'
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js'
import { useNavigate } from 'react-router-dom'
import { BASE_URL } from 'helpers/api_helper';
import PaypalCheckout from './PaypalCheckout';
function PaypalPayment({ showAnimatedToast, onClose, email }) {
    const navigate = useNavigate();

    const initialOptions = {
        clientId: process.env.REACT_APP_PAYPAL_CLIENTID,
        currency: "EUR",
    }


    const styles = {
        shape: "rect",
        layout: "vertical",
    }

    const onCreateOrder = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/paypal/createorder`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            })

            const data = await response.json();
            return data.orderId;

        } catch (error) {
            console.error("Error creating PayPal order:", error);
            showAnimatedToast('error', 'Impossible de créer la commande');
            throw error;
        }
    }


    const onApprove = async (data) => {
        try {
            console.log(data);
            onClose();
            if (!data?.orderID) {
                showAnimatedToast('error', 'Order ID manquant');
                throw new Error("Invalid order ID");
            }

            const response = await fetch(`${BASE_URL}/api/paypal/capturepayment/${data?.orderID}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email: email })
            });

            const result = await response.json();
            console.log(result);
            // navigate("/complete-payment")
            // window.location.href = "/complete-payment";
            showAnimatedToast('success', 'Paiement réussi !');
            console.log("payment completed successfully");
        } catch (error) {
            console.error("Error verifying Paypal order: ", error);
            showAnimatedToast('error', 'Échec de la capture du paiement');
            // navigate("/complete-payment");
            // window.location.href = "/cancel-payment";
            console.log("payment completed successfully");
        }
    }

    const onError = (error) => {
        console.error("PayPal error ", error);
        onClose();
        // window.location.href = "/cancel-payment";
        // navigate("/complete-payment");
        showAnimatedToast('error', 'Paiement refusé');
        console.log("payment refused");

    }
    const buttonRef = useRef(null);
    return (
        <>
            {/* <div
                id="paypal-button-container"
                className="card shadow-sm h-100 paypal-hosted-button p-3"
                // style={{ cursor: 'pointer' }}
                data-paypal-button-id="VOTRE_ID_BOUTON"
            >
                <div className="card-body text-center p-2 d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
                    <img src="/paypalLogo.png" alt="Logo Paypal" width="80" className="d-block mx-auto mb-2" />
                    <h5 className="card-title fw-bold mb-2 text-dark fs-6">Eurl Mobile Apps Dz</h5>
                </div>
                
                <PaypalCheckout amount={21.00} />
            </div> */}

            {/* <PayPalScriptProvider options={initialOptions}>
                <div
                    onClick={() => {
                        // simulate click on PayPal button
                        if (buttonRef.current) {
                            buttonRef.current.click();
                        }
                    }}
                    className="card shadow-sm h-100 paypal-hosted-button"
                    style={{ cursor: 'pointer' }}
                >
                    <div className="card-body text-center p-2 d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
                        <img src="/paypalLogo.png" alt="Logo Paypal" width="80" className="d-block mx-auto mb-2" />
                        <h5 className="card-title fw-bold mb-2 text-dark fs-6">Eurl Mobile Apps Dz</h5>
                    </div>


                    <div style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}>
                        <PayPalButtons
                            style={styles}
                            createOrder={onCreateOrder}
                            onApprove={onApprove}
                            onError={onError}
                            fundingSource="paypal"
                            ref={buttonRef}
                        />
                    </div>
                </div>
            </PayPalScriptProvider> */}
            {/* Animated Toast */}

            <PayPalScriptProvider options={initialOptions}>
                <div
                    id="paypal-button-container"
                    className="card shadow-sm h-100 paypal-hosted-button p-3"
                    // style={{ cursor: 'pointer' }}
                    data-paypal-button-id="VOTRE_ID_BOUTON"
                >
                    <div className="card-body text-center p-2 d-flex flex-column justify-content-center align-items-center" style={{ height: '100%' }}>
                        <img src="/paypalLogo.png" alt="Logo Paypal" width="80" className="d-block mx-auto mb-2" />
                        <h5 className="card-title fw-bold mb-2 text-dark fs-6">Eurl Mobile Apps Dz</h5>
                    </div>

                    <PayPalButtons
                        style={styles}
                        createOrder={onCreateOrder}
                        onApprove={onApprove}
                        onError={onError}
                        fundingSource='paypal'
                    >
                    </PayPalButtons>
                </div>

            </PayPalScriptProvider>
        </>
    )
}

export default PaypalPayment